/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { ElasticsearchResourceInfo } from '@modules/cloud-api/v1/types'
import type { StackDeployment } from '@modules/ui-types'
import Feature from '@modules/utils/feature'

import { getStackDeployment } from '@/reducers/stackDeployments'

import { withStackDeploymentRouteParams } from '../StackDeploymentEditor'
import { migrateToIlm } from '../../actions/ilm/migrateToIlm'
import { isFeatureActivated } from '../../selectors'

import IlmMigration from './IlmMigration'

import type { IndexPatternConversion } from '../../actions/ilm/migrateToIlm'
import type { WithStackDeploymentRouteParamsProps } from '../StackDeploymentEditor'

type StateProps = {
  stackDeployment: StackDeployment | undefined
  ilmMigrationFeature: boolean
}

type DispatchProps = {
  migrateToIlm: (params: {
    deployment: StackDeployment
    resource: ElasticsearchResourceInfo
    indexPatterns: IndexPatternConversion[]
  }) => void
}

type ConsumerProps = WithStackDeploymentRouteParamsProps

const mapStateToProps = (state: any, { stackDeploymentId }: ConsumerProps): StateProps => ({
  stackDeployment: getStackDeployment(state, stackDeploymentId),
  ilmMigrationFeature: isFeatureActivated(state, Feature.ilmMigrationFeature),
})

const mapDispatchToProps: DispatchProps = {
  migrateToIlm,
}

export default withStackDeploymentRouteParams(
  connect<StateProps, DispatchProps, ConsumerProps>(
    mapStateToProps,
    mapDispatchToProps,
  )(IlmMigration),
)
